import { DATETIME_WITH_SECONDS_FORMAT } from "@/config/date";
import { FrontendAddonVersionRaw } from "@/domain/FrontendAddon";
import { parseDateTimeOrISODateTime } from "@/utils/dateFnsHelper";
import { format } from "date-fns";

export const getFrontendAddonVersionName = ({
  id,
  name,
}: Pick<FrontendAddonVersionRaw, "id" | "name">): string =>
  name || id.slice(0, 5);

export const formatFrontendAddonVersionDisplayName = ({
  id,
  name,
  updated_at,
}: Pick<FrontendAddonVersionRaw, "id" | "name" | "updated_at">): string => {
  const parsedUpdatedAt = parseDateTimeOrISODateTime(updated_at);
  const versionName = getFrontendAddonVersionName({ id, name });
  if (!parsedUpdatedAt) return versionName;
  return `${versionName} (${format(parsedUpdatedAt, DATETIME_WITH_SECONDS_FORMAT)})`;
};
